import app from 'app';

import parallax from 'layout/parallax';
import intro from 'layout/intro';
import timeline from 'layout/timeline';
import stackedImages from 'layout/stacked-images';
import collectionSlider from 'layout/collection-slider';
import horizontalScroll from 'layout/horizontal-scroll';
import video from 'layout/video';

app.add({
  intro,
  video,
  timeline,
  parallax,
  'stacked-images': stackedImages,
  'collection-slider': collectionSlider,
  'horizontal-scroll': horizontalScroll,
});

app.mount();
